import { render, staticRenderFns } from "./ReviewsOverview.vue?vue&type=template&id=109f0454&"
import script from "./ReviewsOverview.vue?vue&type=script&lang=js&"
export * from "./ReviewsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsOverview.vue?vue&type=style&index=0&id=109f0454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports